module.exports = __webpack_public_path__ + "static/media/planning-info.92d70453.png";